import React, { Component } from "react";
import { observer } from "mobx-react";
import "./index.css";
import Tab from "../tap";
import Title from "../GoBackShop";
import { ListView } from "antd-mobile";
import { guideList } from "../../static/js/http";
import { withRouter } from "react-router-dom";
@observer
class Guide extends Component {
  constructor() {
    super();
    const ds = new ListView.DataSource({
      rowHasChanged: (r1, r2) => r1 !== r2,
    });
    this.state = {
      dataArr: [],
      page: 0, //页码
      size: 8, // 每页条数
      totalPage: "", //总页数
      totalElements: "",
      dataSource: ds, //长列表加载数据源
      isLoading: true, //是否加载中
      isHasMore: false, //是否还有更多数据
      refreshing: false,
      contHeight: 0,
      scrTop: 0,
      newLoading: false,
      type: "video",
      tabs: [
        {
          id: 1,
          name: "视频",
          value: "video",
          selected: true,
        },
        {
          id: 2,
          name: "文章",
          value: "article",
          selected: false,
        },
      ],
    };
  }

  componentDidMount() {
    this.getList();
  }
  getList() {
    this.setState({
      newLoading: true,
    });
    guideList({
      page: this.state.page,
      size: this.state.size,
      type: this.state.type,
    })
      .then((res) => {
        if (res.msg === "success") {
          if (res.data.storeExpertEntities.length !== 0) {
            let data = this.state.dataArr.concat(res.data.storeExpertEntities);
            this.setState(
              {
                ...this.state,
                dataSource: this.state.dataSource.cloneWithRows(data),
                page: this.state.page + 1,
                totalPage: res.data.totalPages,
                totalElements: res.data.totalElements,
                dataArr: data,
                isLoading: false,
                newLoading: false,
              },
              this.getContentHeight
            );
          } else {
            this.setState({
              isLoading: false,
              newLoading: false,
            });
          }
        } else {
          this.setState({
            isLoading: false,
            newLoading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
          newLoading: false,
        });
      });
  }
  getData() {
    guideList({
      page: this.state.page,
      size: this.state.size,
      type: this.state.type,
    })
      .then((res) => {
        if (res.msg === "success") {
          if (res.data.storeExpertEntities.length !== 0) {
            let data = this.state.dataArr.concat(res.data.storeExpertEntities);
            this.setState(
              {
                ...this.state,
                dataSource: this.state.dataSource.cloneWithRows(data),
                page: this.state.page + 1,
                totalPage: res.data.totalPages,
                totalElements: res.data.totalElements,
                dataArr: data,
                isLoading: false,
                newLoading: false,
              },
              this.getContentHeight
            );
          } else {
            this.setState({
              isLoading: false,
              newLoading: false,
            });
          }
        } else {
          this.setState({
            isLoading: false,
            newLoading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
          newLoading: false,
        });
      });
  }
  // 滑动时触发
  onEndReached = (event) => {
    if (this.state.page + 1 <= this.state.totalPage) {
      if (this.state.totalElements - this.state.dataArr.length >= 1) {
        setTimeout(() => {
          this.setState({
            ...this.state,
            refreshing: true,
            isLoading: true,
          });
          this.getData();
        }, 1000);
      } else {
        this.setState({
          ...this.state,
          refreshing: true,
          isLoading: false,
          hasMore: false,
        });
        setTimeout(() => {
          this.setState({
            ...this.state,
            refreshing: false,
            isLoading: false,
          });
        }, 1000);
      }
    } else {
      this.setState({
        ...this.state,
        refreshing: true,
        isLoading: true,
        hasMore: false,
      });
      setTimeout(() => {
        this.setState({
          ...this.state,
          refreshing: true,
          isLoading: false,
        });
      }, 1000);
    }
  };
  changgeScrollTop(e) {
    if (e.target.clientHeight > this.state.contHeight) {
      let contDom = document.querySelector(".article-body");
      if (!contDom) {
        e.target.scrollTop = 0;
      }
    }
  }
  // 初始化获取元素高度
  getContentHeight() {
    let contHeight = document.querySelector(".am-list-view-scrollview-content");
    if (contHeight) {
      this.setState({ contHeight: contHeight.offsetHeight });
    }
  }
  //   详情页
  goDetail(item) {
    this.props.history.push(`/guidedetail/${item.id}`);
  }
  // tab切换
  switch(item) {
    let arr = this.state.tabs.map((p) => {
      p.selected = false;
      if (item.id === p.id) {
        p.selected = !p.selected;
      }
      return p;
    });
    this.setState(
      {
        tabs: arr,
        type: item.value,
        page: 0,
        dataArr: [],
        dataSource: this.state.dataSource.cloneWithRows([]),
      },
      () => {
        this.getList();
      }
    );
  }
  render() {
    const Loading = () => {
      return (
        <div className="loading">
          <span></span>
          <p>正在加载...</p>
        </div>
      );
    };
    const row = (rowData, sectionID, rowID) => {
      // 这里rowData,就是上面方法cloneWithRows的数组遍历的单条数据了，直接用就行
      return (
        <div
          className="item"
          key={rowID}
          onClick={() => {
            this.goDetail(rowData);
          }}
        >
          <img
            src={
              "https://files.cochat.lenovo.com/download/dbb26a06-4604-3d2b-bb2c-6293989e63a7/" +
              rowData.cover
            }
            alt=""
          />
          <div className="card">
            <span className="title">{rowData.title}</span>
            <div>
              <span>
                {rowData.createTime.replaceAll("-", "/").split(" ")[0]}
              </span>
              <span>{rowData.author || rowData.creater}</span>
            </div>
          </div>
        </div>
      );
    };
    return (
      <div className="guide">
        <Title />
        <div className="tabs">
          {this.state.tabs.map((item, index) => (
            <span
              className={item.selected ? "active" : ""}
              key={index}
              onClick={() => this.switch(item)}
            >
              {item.name}
            </span>
          ))}
        </div>
        <div className="box">
          {this.state.newLoading ? (
            <Loading />
          ) : (
            <ListView
              ref={(el) => (this.lv = el)}
              dataSource={this.state.dataSource}
              initialListSize={20}
              renderFooter={() =>
                this.state.isLoading ? (
                  <div className="footer">
                    {this.state.isHasMore ? "加载中..." : "暂无更多数据"}
                  </div>
                ) : (
                  ""
                )
              }
              scrollEventThrottle={30}
              renderRow={row}
              onEndReachedThreshold={20}
              onEndReached={this.onEndReached.bind(this)}
              onScroll={(e) => this.changgeScrollTop(e)}
              pageSize={1}
              style={{
                height: "96%",
                overflow: "auto",
              }}
            />
          )}
        </div>
        <Tab />
      </div>
    );
  }
}
export default withRouter(Guide);
